import { useState } from "react";
import Button from "@components/forms/Button/Button";
import FlashProps from "@ltypes/flashProps";
import { FaPlay } from "react-icons/fa6";
import Select from "@components/forms/Select/Select";
import Duration from "@components/forms/Duration/Duration";
import './TimerFlash.scss';

type TimerFlashProps = {
} & FlashProps;

function TimerFlash(props: TimerFlashProps) {
    const [timer, setTimer] = useState<string>('00:05:00');

    const handleStart = (timerValue: string) => {
        props.onStart({
            timer: timerValue,
        });
    };

    return (
        <>
            <div className="d-flex justify-content-center gap-3">
                <Button size="sm" className="secondary" onClick={() => handleStart('00:05:00')}>05:00</Button>
                <Button size="sm" className="secondary" onClick={() => handleStart('00:10:00')}>10:00</Button>
                <Button size="sm" className="secondary" onClick={() => handleStart('00:15:00')}>15:00</Button>
            </div>
            <div className="mt-2 d-flex justify-content-center align-items-end gap-3">
                <Duration value="00:05:00" showHours onChange={setTimer}/>
                <Button size="sm" onClick={() => handleStart(timer)}><FaPlay/></Button>
            </div>
        </>
    );
}

export default TimerFlash;
